/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Genre_TextbooksInputs */

const en_onboarding_genre_textbooks = /** @type {(inputs: Onboarding_Genre_TextbooksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Textbooks`)
};

const es_onboarding_genre_textbooks = /** @type {(inputs: Onboarding_Genre_TextbooksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Libros de texto`)
};

/**
* | output |
* | --- |
* | "Textbooks" |
*
* @param {Onboarding_Genre_TextbooksInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_genre_textbooks = /** @type {((inputs?: Onboarding_Genre_TextbooksInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Genre_TextbooksInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_genre_textbooks(inputs)
	return en_onboarding_genre_textbooks(inputs)
});